import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../filters';
import users from '../../users';

export default {
  name: 'customerProperties',
  components: {
    DataGridComp: require('../../customcontrols/datagrid.vue').default,
    EmptyStates: require('@/customcontrols/emptyState/emptyState.vue').default,
  },
  mixins: [users],
  props: {
    custkey: {
      type: String,
      required: true
    },
    items: {
      type: Array,
      default: []
    },
    refName: {
      type: String,
      default: null,
    }
  },
  data: function () {
    return {
      lang: '',
      properties: null,
      propertiesCols: [],
      totalRow: 0,
      pageingOption: { pageSize: 10, total: 0, page: 1 },

      selectedPropertyId: 0,
      selectedProperty: null
    }
  },
  created() {
    this.fillPropertyColumns();
    this.getProperties();
  },
  methods: {
    PropertiesPageChanging(pInfo) {
      this.pageingOption.page = pInfo.pageNumber;
      this.pageingOption.pageSize = pInfo.pageSize;

      this.getProperties();
    },

    getProperties() {
      if (this.items.length > 0) {
        this.properties = this.items;
        this.totalRow = this.items.length;
        return;
      }

      var parameters = {
        custkey: this.custkey,
        loginEmail: this.getLoginName(),
        Options: this.pageingOption
      }

      axios.post('/Enquiries/getProperties', parameters)
        .then(response => {
          if (response.status == 200) {
            this.properties = response.data.items;
            this.totalRow = response.data.itemsCount;

            if (response.data.items.length > 0) {
              this.selectedPropertyId = response.data.items[0].propertyId;
              this.selectedProperty = response.data.items[0];
              this.$emit('selectProp', this.selectedPropertyId, this.selectedProperty);
            }
          }
        })
        .catch(e => {  return false; })
    },
    selectProperty(info) {
      if (info.newRowIndex == info.prevRowIndex)
        return;

      this.selectedProperty = info.rows[info.newRowIndex].data;
      this.selectedPropertyId = info.rows[info.newRowIndex].data.propertyId;
      this.$emit('selectProp', this.selectedPropertyId, this.selectedProperty);
    },
    fillPropertyColumns() {
      if (this.cols && this.cols.length > 0) {
        this.propertiesCols = [...this.cols];
        return;
      }

      let Cols = [];

      Cols.push({ dataField: 'town', caption: this.$t('enquiriesAccount.town') });
      Cols.push({ dataField: 'township', caption: this.$t('enquiriesAccount.township') });
      Cols.push({ dataField: 'plotNo', caption: this.$t('enquiriesAccount.plotNo') });
      Cols.push({ dataField: 'propRef', caption: this.$t('enquiriesAccount.propRef') });
      Cols.push({ dataField: 'billingGroup', caption: this.$t('enquiriesAccount.billingGroup') });
      Cols.push({ dataField: 'custkey', caption: this.$t('enquiriesAccount.custkey') });
      Cols.push({ dataField: 'tenantIdNo', caption: this.$t('enquiriesAccount.tenantIdNo') });
      Cols.push({ dataField: 'ownerCustkey', caption: this.$t('enquiriesAccount.ownerCustkey') });
      Cols.push({ dataField: 'ownerIdNo', caption: this.$t('enquiriesAccount.ownerIdNo') });
      Cols.push({ dataField: 'propertyAddress', caption: this.$t('enquiriesAccount.propertyAddress') });
      Cols.push({ dataField: 'propertyBuildingName', caption: this.$t('enquiriesAccount.propertyBuildingName') });
      Cols.push({ dataField: 'applicationCount', caption: this.$t('enquiriesPropertyDetails.applications') });
      Cols.push({ dataField: 'waterService', caption: this.$t('enquiriesAccount.waterService') });
      Cols.push({ dataField: 'sewerService', caption: this.$t('enquiriesAccount.sewerService') });
      Cols.push({ dataField: 'electricityService', caption: this.$t('enquiriesPropertyDetails.Electricity') });
      Cols.push({ dataField: 'propConsumptionType', caption: this.$t('enquiriesAccount.propConsumptionType') });
      Cols.push({ dataField: 'licenseNo', caption: this.$t('enquiriesPropertyDetails.licenseNo') });
      Cols.push({ dataField: 'licenseStatus', caption: this.$t('enquiriesPropertyDetails.licenseStatus') });
      Cols.push({ dataField: 'waterTariff', caption: this.$t('enquiriesAccount.waterTariff') });
      Cols.push({ dataField: 'sewerTariff', caption: this.$t('enquiriesAccount.sewerTariff') });
      Cols.push({ dataField: 'electricityTariff', caption: this.$t('enquiriesPropertyDetails.electricityTariff') });
      Cols.push({ dataField: 'propInfoFlag1Data', caption: this.$t('enquiriesAccount.propInfoFlag1Data') });
      Cols.push({ dataField: 'propInfoFlag2Data', caption: this.$t('enquiriesAccount.propInfoFlag2Data') });
      Cols.push({ dataField: 'propInfoFlag3Data', caption: this.$t('enquiriesAccount.propInfoFlag3Data') });
      Cols.push({ dataField: 'propInfoFlag4Data', caption: this.$t('enquiriesAccount.propInfoFlag4Data') });
      Cols.push({ dataField: 'propInfoFlag5Data', caption: this.$t('enquiriesAccount.propInfoFlag5Data') });

      this.propertiesCols = Cols;
    },
    showPropertyDetails(info) {
      let routeData = this.$router.resolve({ name: 'propertyDetails', params: { PROPERTYID: info.data.propertyId } });
      window.open(routeData.href, '_blank');
    },
  },
}

